import React, { useEffect, useState } from "react";
// import './MasterFileTable.css';
import "../../GlobalCss/SPF/MasterFileTable.css";
import Cookies from "js-cookie";
import axios from "axios";
import { Table, Spin, Form, Input, Popconfirm, Typography, Button, Pagination, Select, message } from "antd";
import { selectMasterfileFrequency, updateMasterfile } from "../../Repository/MasterFileRepository";
import { EditFilled, CheckCircleFilled, CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";

const MasterFileTable = ({ dataColumns, selectfrequency, sendDataToParent, }) => {
    const [masterData, setMasterData] = useState([])
    const jwtToken = Cookies.get("jwt_token");
    const [tableLoader, setTableLoader] = useState(false)
    const [rowData, setRowData] = useState([]);
    const dataCol = dataColumns
    const frequency = selectfrequency
    const [form] = Form.useForm();
    const [searchRow, setSearchRow] = useState("")
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.file_number === editingKey;

    const [selectedPayDate, setSelectedPayDate] = useState();
    const [PayDates, setPayDates] = useState([]);
    const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    useEffect(() => {
        if (frequency !== "") {
            let temp = frequency
            callMasterRepositoryMethod(temp)
        }
    }, [frequency])
    useEffect(() => {
        if (dataCol.length === 0) {
            columns.length = 0
        }
    }, [dataCol])
    const editableSet = [
        "temp_rate", "rt_wk1", "ot_wk1", "dt_wk1", "rt_wk2", "ot_wk2", "dt_wk2", "rt_total", "ot_total", "dt_total", "sal_amnt",
        "holiday_hrs", "pto_hrs", "sick_hrs", "covid_hrs", "training_hrs", "gym_amnt", "fmla_amnt", "sevpay_amnt", "bonus_amnt",
        "missingInPaychexList", "remarks"
    ]
    const widthSet = [
        "missingInPaychexList", "sick_hrs", "covid_hrs", "training_hrs", "fmla_amnt", "sevpay_amnt", "bonus_amnt", "sal_amnt",
        'ticket_Number', 'holiday_hrs', 'remarks', 'chequesequence', "gym_amnt", "WeekendDate"
    ]
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.file_number)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.client)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.pcx_emp_name).toLowerCase().includes(value.toLowerCase())
            );
        },
    });
    const sortProps = (column) => {
        const sortElement = dataCol.some(item => item.key === column);
        if (column === "file_number" || sortElement || "comp_code" || "state" || "client"
            || "hire_date" || "rate_type") {
            return (
                {
                    sorter: (a, b) => {
                        // Check if a[column] and b[column] are defined
                        if (a[column] && b[column]) {
                            return a[column].localeCompare(b[column]);
                        }
                        // If either a[column] or b[column] is undefined, return 0 (no change)
                        return 0;
                    },
                    sortDirections: ['descend', 'ascend'],
                    showSorterTooltip: false,
                }
            )
        }
    };
     const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        return `${String(dateObject.getMonth() + 1).padStart(2, '0')}/${String(dateObject.getDate()).padStart(2, '0')}/${dateObject.getFullYear()}`;
    };
    const columns = [
        { title: "Co Code", dataIndex: "comp_code", key: 'comp_code', fixed: "left", width: 120, ...sortProps('comp_code'), },
        {
            title: "File Number", dataIndex: 'file_number', key: 'file_number', fixed: "left", width: 130,
            ...sortProps('file_number'), ...filterProps(),
        },
        // { title: "Employee Name", dataIndex: "pcx_emp_name", key: 'pcx_emp_name', fixed: "left", width: 150, },
        { title: "State", dataIndex: "state", key: 'state', width: 100, ...sortProps('state'), },
        { title: "Client", dataIndex: "client", key: 'client', width: 150, ...sortProps('client'), },
        { title: "Hire Date", dataIndex: "hire_date", key: 'hire_date', width: 150,  ...sortProps('hire_date'), },
        { title: "Rate Type", dataIndex: "rate_type", key: 'rate_type', width: 150, ...sortProps('rate_type'), },
        // { title: "Payrate", dataIndex: "pay_rate", key: 'pay_rate', width: 150, },
        { title: "Frequency", dataIndex: "pay_frequency", key: 'pay_frequency', width: 150, },
        ...dataCol.map(data => ({
            title: data.value,
            dataIndex: data.key,
            key: data.key,
            width: widthSet.includes(data.key) ? 200 : 115,
            editable: editableSet.includes(data.key) ? true : false,
            ...sortProps(data.key),
        })),
        {
            title: 'Action',
            dataIndex: 'operation',
            width: 70,
            fixed: "right",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => editMasterfileRowData(record)} onCancel={cancel}>
                            <Typography.Link
                                style={{
                                    marginRight: 8,
                                }}
                            >
                                <CheckCircleFilled style={{ fontSize: 19, color: 'green' }} className="save-cancel-icon" />
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseCircleFilled style={{ fontSize: 19, color: 'red' }} className="save-cancel-icon" />
                        </Typography.Link>
                    </span>
                ) : (
                    <Typography.Link onClick={() => edit(record)}>
                        <EditFilled style={{ fontSize: 18, color: '#003A8C' }} />
                    </Typography.Link>
                );
            },
        }
    ]

    const callMasterRepositoryMethod = async (frequency) => {
        setTableLoader(true)
        const response = await selectMasterfileFrequency(frequency)
        if (response !== null) {
            setMasterData(response)
            sendDataToParent(response)
        }
        else {
            setMasterData([])
        }
        setTableLoader(false)
    }
    const edit = (record) => {
        setRowData(record)
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.file_number);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
            return false;
        }
        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
        return true;
    };

    const compareLists = (rowData, currentRowData) => {
        if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
            return false;
        }
        const result = compareObjects(rowData, currentRowData);
        return result;
    };
    const editMasterfileRowData = async (props) => {
        try {
            const currentRowData = await form.getFieldValue();
            const comparision = compareLists(rowData, currentRowData);
            if (comparision === false) {
                const data = {
                    "filenumber": currentRowData.file_number,
                    "temp_rate": currentRowData.temp_rate,
                    "id": 0,
                    "rt_wk1": currentRowData.rt_wk1,
                    "ot_wk1": currentRowData.ot_wk1,
                    "dt_wk1": currentRowData.dt_wk1,
                    "rt_wk2": currentRowData.rt_wk2,
                    "ot_wk2": currentRowData.ot_wk2,
                    "dt_wk2": currentRowData.dt_wk2,
                    "rt_total": currentRowData.rt_total,
                    "ot_total": currentRowData.ot_total,
                    "dt_total": currentRowData.dt_total,
                    "sal_amount": currentRowData.sal_amnt,
                    "holiday_hrs": currentRowData.holiday_hrs,
                    "pto_hrs": currentRowData.pto_hrs,
                    "sick_hrs": currentRowData.sick_hrs,
                    "covid_hrs": currentRowData.covid_hrs,
                    "training_hrs": currentRowData.training_hrs,
                    "gym_amnt": currentRowData.gym_amnt,
                    "fmla_amnt": currentRowData.fmla_amnt,
                    "sevpay_amnt": currentRowData.sevpay_amnt,
                    "bonus_amnt": currentRowData.bonus_amnt,
                    "missingInPaychexList": currentRowData.missingInPaychexList,
                    "remarks": currentRowData.remarks
                }
                const updateresponse = await updateMasterfile(data)
                if (updateresponse.data.statusCode === 200) {
                    const res = await selectMasterfileFrequency(frequency)
                    if (res !== null) {
                        setMasterData(res)
                        sendDataToParent(res)
                    }
                    SuccessMessage(updateresponse.data.message)
                }
                else if (updateresponse.data.statusCode === 204) {
                    InfoMessage(updateresponse.data.message)
                }
                else {
                    ErrorMessage(updateresponse.data.message)
                }
                setEditingKey("");
            }
            else {
                InfoMessage("No changes made. Edit and try again.")
            }
        }
        catch (err) {
            return err
        }
    }
    //Get PayDate Dates
    const GetPayDates = async () => {
        try {
            const url = `${process.env.REACT_APP_BASE_URL}Paychex/getPayDates`;
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${jwtToken}`,
                },
            };

            const response = await axios.get(url, config);
            const payDatesResponse = response.data;

            if (payDatesResponse.isSuccess) {
                const payDates = JSON.parse(payDatesResponse.payload).map(date => {
                    const dateObject = new Date(date);
                    const formattedDate = `${String(dateObject.getMonth() + 1).padStart(2, '0')}-${String(dateObject.getDate()).padStart(2, '0')}-${dateObject.getFullYear()}`;

                    return {
                        label: formattedDate,
                        value: date,
                    };
                });

                setPayDates(payDates);

            } else {
                console.error("Error fetching pay dates:", payDatesResponse.message);
            }
        } catch (error) {
            console.error("Error fetching pay dates:", error);
        }
    };

    useEffect(() => {
        GetPayDates();
    }, []);

    const GetDataForPayDate = async (selectedPayDate) => {
        if (selectedPayDate) {
            try {

                setTableLoader(true);
                // Extracting only the date portion from the selectedPayDate string
                const dateObject = new Date(selectedPayDate);
                const formattedDate = `${dateObject.getFullYear()}-${String(dateObject.getMonth() + 1).padStart(2, '0')}-${String(dateObject.getDate()).padStart(2, '0')}`;
    
                // Mapping the frequency value
                let frequency;
                if (selectfrequency === "Weekly") {
                    frequency = "W";
                } else if (selectfrequency === "Bi-Weekly") {
                    frequency = "B";
                }
    
                // Setting selected pay date
                setSelectedPayDate(selectedPayDate);
    
                // Constructing the request body as JSON
                const requestBody = {
                    paydate: formattedDate,
                    frequency: frequency,
                };
    
                const url = `${process.env.REACT_APP_BASE_URL}Paychex/GetDataForPayDate?paydate=${formattedDate}&frequency=${frequency}`;
                const config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                };
    
                // Make POST request
                const response = await axios.post(url, requestBody, config);
    
                if (response.data.statusCode === 200) {
                    let data = JSON.parse(response.data.payload);
    
                    // Formatting dates
                    const formattedData = data.map(item => {
                        let newHireDate, newTermDate, newPayDate;
    
                        // Format hire_date
                        if (item.hire_date) {
                            const [fullDate, time] = item.hire_date.split('T');
                            const [year, month, date] = fullDate.split('-');
                            const [hour, minute, sec] = time.split(':');
                            const second = sec.replace("Z", "");
                            const dateTime = new Date(year, month - 1, date, hour, minute, second);
                            newHireDate = dateTime.toLocaleDateString("en-us");
                        }
    
                        // Format term_date
                        if (item.term_date) {
                            const [fullDate_td, time_td] = item.term_date.split('T');
                            const [year_td, month_td, date_td] = fullDate_td.split('-');
                            const [hour_td, minute_td, sec_td] = time_td.split(':');
                            const second_td = sec_td.replace("Z", "");
                            const dateTime_td = new Date(year_td, month_td - 1, date_td, hour_td, minute_td, second_td);
                            newTermDate = dateTime_td.toLocaleDateString("en-us");
                        }
    
                        // Format pay_date
                        if (item.payDate) {
                           
                            const [fullDate, timeWithTimezone] =  item.payDate.split('T');
                            const [year, month, date] = fullDate.split('-');
                            const [time] = timeWithTimezone.split('+'); // Remove timezone if exists
                            const [hour, minute, sec] = time.split(':');
                            newPayDate=new Date(year, month - 1, date, hour, minute, sec).toLocaleDateString("en-us");
                        }
    
                        return {
                            ...item,
                            hire_date: newHireDate || item.hire_date,
                            term_date: newTermDate || item.term_date,
                            payDate: newPayDate || item.payDate,
                        };
                    });

                   
    
                    // Update state and parent
                    setMasterData(formattedData);
                    sendDataToParent(formattedData);
                } else {
                    // Handle case where response data is not valid
                    message.info(response.data.message);
                    console.error("Invalid data format:", response.data);
                }
                setTableLoader(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setTableLoader(false);
            }
        } else {
            setSelectedPayDate(undefined);
            callMasterRepositoryMethod(frequency);
        }
    };
    
    return (<>
        <div className="masterfile-search-class">
            <Select
                value={selectedPayDate}
                className="master-frequency-select"
                style={{ width: 170, height: 40, marginRight: "20px" }} size="large"
                placeholder={<span className="placeholder-span" style={{ color: 'rgba(59, 82, 223, 1)' }}>Select PayDate</span>}
                options={PayDates}
                allowClear
                onChange={GetDataForPayDate}
            />
            <Input
                placeholder="Search File Number \ Employee Name \ Client"
                className="MF-searchrow"
                // style={{ borderColor: "#3B52DF", color: "#3B52DF" }}
                onChange={(e) => setSearchRow(e.target.value)}
                allowClear
                suffix={
                    <SearchOutlined
                        style={{ color: "#7185FF", justifyContent: "space-between" }}
                    />
                }
            />
        </div>
        <div className={masterData.length > 0 ? "masterfile-table-class" : "masterfile-empty-table"}>
            {
                tableLoader ? <Spin tip="Loading...">
                    <Form form={form} component={false}>
                        <Table className="masterfile-table" rowClassName="editable-row"
                            components={{ body: { cell: EditableCell, }, }}
                            columns={mergedColumns} scroll={{ x: "max-content", y: 400 }}
                            dataSource={masterData} >
                        </Table>
                    </Form> </Spin> :
                    <Form form={form} component={false}>
                        <Table className="masterfile-table" rowClassName="editable-row"
                            components={{ body: { cell: EditableCell, }, }} bordered
                            columns={mergedColumns} scroll={{ x: "max-content", y: 400 }}
                            dataSource={masterData} >
                        </Table>
                    </Form>
            }
        </div>
    </>)
}

export default MasterFileTable;